export var USPACY_API = {
    GET_FUNNELS: '/crm/v1/entities/deals/funnel',
    GET_PORTAL_USERS: '/company/v1/users?list=all&show=all&is_app_bot=false',
};
export var ENTITY_TYPE = {
    LEAD: 'lead',
    DEAL: 'deal',
    CONTACT: 'contact',
};
